import React, { useState, useMemo, useEffect } from "react";
import mainStyle from "../../mainStyle.module.scss";

import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import { cloneDeep } from "lodash";

// Hook
import useAuthScope from "hooks/useAuthScope";

// Components
import BlockAllowModal from './BlockAllowModal';
import { SolidButton } from "components/buttons/SolidRectangleButton";

// Img
import { ReactComponent as BtnUpIcon } from "assets/images/icons/icn_button_up_light.svg";
import { ReactComponent as BtnDownIcon } from "assets/images/icons/icn_button_down_light.svg";

// Const
import { defaultActionsDefinition } from "../../const";

const StyledDropdown = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "100%",
  left: 0,
  marginTop: theme.spacing(1),
  padding: "10px 20px",
  width: "251px",
  backgroundColor: theme.palette.primary.lightBlue,
  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
  borderRadius: 4,
  zIndex: 10,
  "&::before": {
    content: '""',
    position: "absolute",
    top: "-8px",
    left: "14px",
    width: 0,
    height: 0,
    borderLeft: "8px solid transparent",
    borderRight: "8px solid transparent",
    borderBottom: `8px solid ${theme.palette.primary.lightBlue}`,
  },
}));

const ActionSelector = ({
  setAlertInfo,
  tableInstance,
  isShowActionButton,
  setIsShowActionButton,
  selectedInstancesList,
  initCallback
}) => {
  const { auth } = useAuthScope();
  const [actions, setActions] = useState(cloneDeep(defaultActionsDefinition));
  const openedAction = useMemo(() => {
    const openedKey = Object.keys(actions).find(key => actions[key].isOpenModal);
    return actions[openedKey];
  }, [actions])

  const handleActions = (key, props, value) => {
    setActions({
      ...cloneDeep(actions),
      [key]: {
        ...cloneDeep(actions)[key],
        [props]: value
      }
    })
  };

  useEffect(() => {
    return () => {
      setActions(cloneDeep(defaultActionsDefinition));
      setIsShowActionButton(false);
    }
  }, []);

  return (
    <>
      <Box style={{ marginLeft: "5px", position: "relative" }}>
        <SolidButton
          startIcon={isShowActionButton ? <BtnUpIcon /> : <BtnDownIcon />}
          width="100px"
          height="32px"
          onClick={() => setIsShowActionButton(!isShowActionButton)}
        >
          Action
        </SolidButton>
        {isShowActionButton && (
          <StyledDropdown id="clients_action">
            {
              Object.keys(actions)
                .map(key => actions[key])
                .map(({ key, label, icon }) => (
                  <Box
                    key={"clients_action_child_" + key}
                    className={mainStyle["action_item"]}
                    onClick={() => handleActions(key, "isOpenModal", true)}
                  >
                    <img
                      src={icon}
                      alt={label.actionButton}
                    />
                    <span>{label.actionButton}</span>
                  </Box>
                ))
            }
          </StyledDropdown>
        )}
      </Box>

      {
        openedAction &&
        <BlockAllowModal
          {...{
            setAlertInfo,
            actions,
            setActions,
            openedAction,
            selectedInstancesList,
            initCallback
          }}
        />
      }
    </>
  );
}

export default ActionSelector;